module.exports = {"230706001":"向阳街道","230706002":"曙光街道","230706400":"解放经营所","230706401":"昆仑气林场","230706402":"开源河林场","230706403":"么河经营所","230706404":"冲锋经营所","230706405":"翠峦河经营所","230706406":"抚育河经营所","230706407":"尖山河经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230706.json
// module id = 687
// module chunks = 0